var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaterialsVoteModalShowDocIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 4,
    fill: "#363B4D",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9998 10C16.5265 10 18.7798 11.42 19.8798 13.6667C18.7798 15.9133 16.5265 17.3333 13.9998 17.3333C11.4732 17.3333 9.21984 15.9133 8.11984 13.6667C9.21984 11.42 11.4732 10 13.9998 10ZM13.9998 8.66666C10.6665 8.66666 7.81984 10.74 6.6665 13.6667C7.81984 16.5933 10.6665 18.6667 13.9998 18.6667C17.3332 18.6667 20.1798 16.5933 21.3332 13.6667C20.1798 10.74 17.3332 8.66666 13.9998 8.66666ZM13.9998 12C14.9198 12 15.6665 12.7467 15.6665 13.6667C15.6665 14.5867 14.9198 15.3333 13.9998 15.3333C13.0798 15.3333 12.3332 14.5867 12.3332 13.6667C12.3332 12.7467 13.0798 12 13.9998 12ZM13.9998 10.6667C12.3465 10.6667 10.9998 12.0133 10.9998 13.6667C10.9998 15.32 12.3465 16.6667 13.9998 16.6667C15.6532 16.6667 16.9998 15.32 16.9998 13.6667C16.9998 12.0133 15.6532 10.6667 13.9998 10.6667Z",
    fill: "#363B4D",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialsVoteModalShowDocIcon);
export default __webpack_public_path__ + "static/media/Materials_vote_modal_show_doc_icon.b06f2065726d65d899664ddcd4201f28.svg";
export { ForwardRef as ReactComponent };